export default __webpack_public_path__ + "static/media/ic-clock.8b135876.svg";